<template>
  <div>
    <TitleBar>
      <template v-slot:title>
        {{ $gettext('Clients') }}
      </template>
      <template v-slot:buttons>
        <GekkoButton
          v-if="!isGekkoAccountant"
          @click="inviteCustomer()"
          :text="$gettext('Invite Client')"
          data-analytics-click="invite client"
          icon="fa fa-plus"
          class="mr-2"
        />
        <GekkoButton
          v-if="isGekkoAccountant"
          @click="connectGekkoAccountant()"
          :text="$gettext('Connect Gekko Accountant')"
          icon="fa fa-gear"
          class="ml-2"
          variant="danger"
        />
      </template>
    </TitleBar>
    <div class="content">
      <InviteCustomerModal ref="invite_customer_modal" @invite-sent="onInviteSent" />
      <GekkoAccountantModal ref="gekko_accountant_modal" @connected="onGekkoAccountantConnected" />
      <CustomerList ref="customer_list" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GekkoButton from '@/components/GekkoButton'
import TitleBar from '@/components/TitleBar'
import CustomerList from '@/components/accountants/CustomerList'
import InviteCustomerModal from '@/components/accountants/InviteCustomerModal.vue'
import GekkoAccountantModal from '@/components/accountants/GekkoAccountantModal.vue'

export default {
  name: 'Customers',
  components: {
    GekkoButton,
    TitleBar,
    CustomerList,
    InviteCustomerModal,
    GekkoAccountantModal,
  },
  computed: {
    ...mapGetters({
      currentAccountantCompany: 'accountants/getCurrentAccountantCompany',
    }),
    isGekkoAccountant() {
      if (this.currentAccountantCompany.accountant_branding) return this.currentAccountantCompany.accountant_branding.is_gekko_accountant
      else return false
    },
  },
  methods: {
    inviteCustomer() {
      this.$refs.invite_customer_modal.showInviteCustomerModal = true
    },
    connectGekkoAccountant() {
      this.$refs.gekko_accountant_modal.showGekkoAccountantModal = true
    },
    onGekkoAccountantConnected(connection) {
      console.log('onGekkoAccountantConnected', connection)
      this.$refs.customer_list.addGekkoConnection(connection)
    },
    onInviteSent () {
      this.$router.push({ name: 'PendingInvitations' })
    }
  },
}
</script>